export const paymentTerms = [
      "Due on receipt",
        "Net 10 days",
        "Net 15 days",
        "Net 30 days",
        "Net 60 days",
        "Prepay",
        "50% down 50% on shipping",
]